<ng-container *shrdUtcLet="tabActive$ | async as tabActive">
  <div
    *ngIf="alwaysRenderContent || tabActive?.active"
    role="tabpanel"
    [attr.aria-labelledby]="'tab-button-' + tabActive?.tab.id"
    id="shrd-uic-tab-content-{{ tabActive?.tab.contentReference }}"
    [class.d-none]="alwaysRenderContent && !tabActive?.active"
    [class]="containerClass"
  >
    <ng-content></ng-content>
  </div>
</ng-container>
